export default {"src":"/stays/_next/static/media/Partment_Rental_logo_white.b9dd4418.svg","height":36,"width":114,"blurWidth":0,"blurHeight":0};